import { thejamsilFont } from 'src/styles/font';
import { rem } from 'src/styles/function';
import { ICON_PATH, IS_LEAFLET_TYPE } from 'src/utils/constants';
import styled, { css } from 'styled-components';

const IMAGE_PATH = `${process.env.REACT_APP_BASE_S3_IMAGE}/app/leaflet`;

/**
 * @name 전단 마트고 팝업 적용
 */
export const StyledDisplay = styled.section`
  ${IS_LEAFLET_TYPE &&
  css`
    z-index: 100;
    overflow-y: auto;
    position: fixed;
    height: 100%;
    top: 0;
    width: 100%;
    display: flex;
    background: #fff;
    flex-direction: column;
  `}
`;

/**
 * @name 전단 상세 고정영역
 */
export const StyledFixedLeaflet = styled.section`
  position: fixed;
  background-color: #fff;
  width: 100%;
  z-index: 50;
  box-sizing: border-box;
  left: 0;
  top: 0;
  .dim_leaflet {
    position: absolute;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
  }
  @media screen and (min-width: 740px) {
    width: 415px;
    left: 50%;
    transform: translate(-50%, 0);
  }
`;

/**
 * @name 전단 상세 스타일 컴포넌트
 */
export const StyledLeafletDetail = styled.section<{ isCategory?: boolean }>`
  padding-top: ${props => (props.isCategory ? `${rem(125)}` : `${rem(55)}`)};
`;

/**
 * @name 전단 서브 헤더
 */
export const StyledLeafletHeader = styled.div`
  padding: ${rem(10)} ${rem(10)};
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  .list_icon {
    ${thejamsilFont('medium')}
    font-size: ${rem(20)};
    width: 100%;
    text-align: left;
    &::before {
      display: inline-block;
      vertical-align: middle;
      content: '';
      background-image: url('${ICON_PATH}/icon_menu.png');
      background-size: 100% 100%;
      width: ${rem(40)};
      height: ${rem(40)};
      margin-right: ${rem(5)};
    }
  }
  .close_icon {
    width: ${rem(45)};
    img {
      display: block;
      width: 100%;
    }
  }
  .app_icon {
    width: ${rem(90)};
    img {
      display: block;
      width: 100%;
    }
  }
`;

/**
 * @name 전단 카테고리 스타일 컴포넌트
 */
export const StyledLeafletCategory = styled.div`
  position: relative;
  padding: ${rem(5)} ${rem(10)};
  box-sizing: border-box;
  .cate_swiper {
    margin: 0 ${rem(20)} 0 0;
    .swiper-slide {
      width: fit-content;
    }
    .cate_swiper_list {
      width: 100%;
      height: auto;
      div {
        padding: ${rem(15)} ${rem(20)};
        box-sizing: border-box;
        border-radius: ${rem(30)};
        border: 1px solid #666666;
        margin: 0 ${rem(10)} ${rem(10)} 0;
        &.active {
          border-color: #e60012;
          p {
            color: #e60012;
          }
        }
        p {
          ${thejamsilFont('regular')}
          color: #666666;
          font-size: ${rem(15)};
        }
      }
    }
  }
  .cate_more_box {
    position: absolute;
    top: ${rem(-3)};
    left: 0;
    width: 100%;
    height: ${rem(200)};
    z-index: 100;
    background-color: white;
    box-sizing: border-box;
    h2 {
      ${thejamsilFont('medium')}
      font-size: ${rem(16)};
      margin-bottom: ${rem(20)};
      padding-top: ${rem(10)};
      padding-left: ${rem(20)};
    }
    ul {
      width: 100%;
      height: 100%;
      overflow: scroll;
      background-color: #fff;
      padding: 0 ${rem(10)} ${rem(10)};
      box-sizing: border-box;
      li {
        display: inline-block;
        padding: ${rem(15)} ${rem(20)};
        box-sizing: border-box;
        border-radius: ${rem(30)};
        border: 1px solid #666666;
        margin: 0 ${rem(10)} ${rem(10)} 0;
        &.active {
          border-color: #e60012;
          button {
            color: #e60012;
          }
        }
        button {
          ${thejamsilFont('regular')}
          color: #666666;
          font-size: ${rem(15)};
        }
      }
    }
  }
  .more_btn {
    position: absolute;
    top: ${rem(5)};
    right: ${rem(20)};
    transform: translateY(20%);
    z-index: 31;
    button {
      width: ${rem(35)};
      height: ${rem(35)};
      border-radius: ${rem(20)};
      border: solid 1px #666;
      background-color: #fff;
      position: relative;
      z-index: 1;
      box-shadow: 0px 2px 8px -2px rgba(0, 0, 0, 0.2);
      img {
        width: ${rem(24)};
        height: ${rem(24)};
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    img {
      width: 100%;
    }
    &.active {
      top: ${rem(-10)};
      transform: rotate(180deg) translateY(-30%);
      z-index: 101;
    }
    .more-gradient {
      width: ${rem(70)};
      height: ${rem(55)};
      background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0),
        white,
        white
      );
      position: absolute;
      top: ${rem(-10)};
      right: ${rem(-20)};
    }
  }
`;

/**
 * @name 전단 이미지 스타일 컴포넌트
 */
export const StyledLeafletItem = styled.div`
  img {
    display: block;
    width: 100%;
  }
`;

/**
 * @name 전단 페이지네이션 스타일 컴포넌트
 */
export const StyledLeafletPagenation = styled.div`
  position: relative;
  width: 90%;
  height: 3rem;
  left: 50%;
  transform: translate(-50%, 0);
  background: #e60012;
  border-radius: 1.5rem;
  margin-top: 1rem;
  .paper-paging {
    color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    strong {
      ${thejamsilFont('medium')}
      font-size: 22px;
    }
  }
  .next_btn,
  .pre_btn {
    position: absolute;
    top: 0;
    width: 3rem;
    height: 100%;
    margin-top: 0;
    background-repeat: no-repeat;
    background-size: 2.2rem 2.2rem;
  }

  .next_btn {
    right: -0.2rem;
    background-image: url('${IMAGE_PATH}/common/btn_arrow_right.png');
    background-position: calc(100% - 10px) 50%;
  }

  .pre_btn {
    left: 0.3rem;
    background-image: url('${IMAGE_PATH}/common/btn_arrow_right.png');
    background-position: 10px 50%;
    transform: rotate(180deg);
  }
`;

/**
 * @name 전단 공유 버튼
 */
export const StyledShareButton = styled.div`
  margin-top: 1rem;
  height: 5rem;
  position: relative;
  button {
    position: absolute;
    width: ${rem(50)};
    right: 1.3rem;
    padding-bottom: 1rem;
    img {
      width: 100%;
    }
  }
`;
